<template>
    <div>
        <div class="text-center pb-3">
            <span class="h5 font-weight-light">{{transEdit('information-about-locations')}}</span>
        </div>
        <table v-if="companyLocations && companyLocations.length > 0" class="table">
            <thead>
            <tr>
                <th>{{transEdit('information')}}</th>
                <th>{{transEdit('company')}}</th>
                <th>{{transEdit('location')}}</th>
                <th>{{transEdit('address')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="location in companyLocations">
                <td>
                    <button v-if="userIsSubscribedTo(location)"
                            class="btn btn-danger"
                            v-on:click="unsubLocation(location)">
                        {{transEdit('unsubscribe')}}
                    </button>
                    <button v-else
                            class="btn btn-success"
                            v-on:click="subLocation(location)">
                        {{transEdit('subscribe')}}
                    </button>
                </td>
                <td>{{location.name}}</td>
                <td>{{location.address}}</td>
            </tr>
            </tbody>
        </table>
        <div v-else class="alert alert-primary">
            {{transEdit('no-locations-found')}}
        </div>
    </div>
</template>

<script>
    export default {
        props: ['part'],
        name: "customer-dash-locations",
        computed: {
            userLocations: function () {
                return this.part.userlocations;
            },
            companyLocations: function () {
                return this.part.companylocations;
            },
            userLocationIDs: function () {
                return this.part.userlocationids;
            }
        },
        methods: {
            userIsSubscribedTo: function (location) {
                return this.userLocationIDs.indexOf(location.id) > -1;
            },
            subLocation: function (inputLocation) {
                let self = this;

                axios.post(self.part.route_sub, {
                    locationId: inputLocation.id
                })
                .then(function (response) {
                    location.reload();
                })
                .catch(function (error) {
                });
            },
            unsubLocation: function (inputLocation) {
                let self = this;

                axios.post(self.part.route_unsub, {
                    locationId: inputLocation.id
                })
                .then(function (response) {
                    location.reload();
                })
                .catch(function (error) {
                });
            },
        }
    }
</script>

<style scoped>

</style>
